<template>
  <v-dialog persistent v-model="get_dialogMain.dialog" :width="get_dialogMain.withWindows" justify-center>
      <v-card width="auto" tile>
          <v-toolbar dense dark color="blue darken-2">
            <v-toolbar-title> <h3>{{get_dialogMain.title}}</h3> </v-toolbar-title>
            <v-spacer/>
            <v-btn icon dark @click="HIDDE_DIALOG_MAIN"> <v-icon>mdi-close</v-icon></v-btn>
          </v-toolbar>
          <v-card-text class="my-1">
            <v-row dense v-if="get_dialogMain.type != 'returnedInsumos'">
              <v-col cols="12">
                <FormsMainGral titleButton="Agregar"
                  :formCreate="formInsumo"
                  :on-success="addInsumo"
                  :model="insumo"/>
              </v-col>

              <v-col cols="12">
                <v-data-table
                :headers="table.header.titles"
                :items="table.body.data"
                :items-per-page="5"
                class="elevation-2"
                :footer-props="footer"
                dense>
                    <template v-slot:item.Cantidad="{ item }">
                      <v-chip class="ma-1" color="info" dark outlined>{{item.cantidad}}</v-chip>
                    </template>

                    <template v-slot:item.AddInsumo="{ item }">
                      <v-row dense>
                        <v-col cols="12" v-if="!item.nuevo">
                          <v-text-field
                            label="Cantidad a Agregar"
                            v-model="item.added"
                            @input="upAdd(item)"
                            :error-messages="(item.messageAdd) ? `La cantidad no es valido debe ser mayor a 0`: []"
                            type="number"
                            outlined
                            dense/>
                        </v-col>
                      </v-row>
                    </template>

                    <template v-slot:item.ReturnInsumo="{ item }">
                      <v-row dense>
                        <v-col cols="12" v-if="!item.nuevo">
                          <v-text-field
                            label="Cantidad a Regresar"
                            v-model="item.returned"
                            @input="up(item)"
                            :error-messages="(item.message) ? `Se excede a la cantidad utilizada`: []"
                            type="number"
                            min="0"
                            outlined
                            dense/>
                        </v-col>
                      </v-row>
                    </template>

                  <template #footer.page-text="props">
                    {{props.pageStart}} - {{props.pageStop}} de {{props.itemsLength}}
                  </template>
                </v-data-table>
              <!--<DataTableMain :datatable="table" :on-success="successAction" :itemsAction="tableAction"/> -->
              </v-col>

              <v-col cols="12" class="pt-5">
                <v-layout justify-end>
                    <v-btn color="error darken-1" depressed outlined @click="closeDialog" class="mr-3"> Cancelar </v-btn>
                    <v-btn color="success darken-1" depressed outlined @click="saveInsumo" class="mr-3"> Guardar </v-btn>
                </v-layout>
              </v-col>
            </v-row>
          </v-card-text>
      </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import FormsMainGral from '@/components/forms/formsMainGral'
// import DataTableMain from '@/components/tables/DataTableMainLocal'
export default {
  name: 'dialogMain',
  props: ['model'],
  data: () => ({
    table: {
      header: {
        options: [],
        titles: [
          { text: 'Insumo', value: 'nombre', class: 'black--text' },
          { text: 'Cantidad', value: 'Cantidad', class: 'black--text' },
          { text: 'Agregar', value: 'AddInsumo', class: 'black--text' },
          { text: 'Regresar', value: 'ReturnInsumo', class: 'black--text' }
        ],
        loading: false
      },
      body: {
        data: [],
        actions: []
      },
      footer: { paging: true }
    },
    footer: {
      showFirstLastPage: true,
      'items-per-page-text': 'Registros por página'
    },
    formInsumo: {
      fields: []
    },
    insumos: [],
    insumo: {},
    modelSend: {},
    // returned Insumos Objets
    insumosReturned: []
  }),
  components: {
    FormsMainGral
    // DataTableMain
  },
  mounted () {
    console.log('modelMain', this.model)
    this.user = this.$cookies.get('user')

    if (this.model.last_movement.estatus.formulario.fieldsDetail) {
      this.formInsumo.fields = Object.assign([], this.model.last_movement.estatus.formulario.fieldsDetail)
    }
    this.table.body.data = []
    if (this.model.last_movement.detalle.descripcion.insumos) {
      this.table.body.data = Object.assign([], this.model.last_movement.detalle.descripcion.insumos)
    }
  },
  methods: {
    successAction (item) {
      this[item.action](item)
    },
    tableAction (item) {
      this[item.action](item)
    },
    ...mapActions(['getFormServicesAction', 'urlGetServiceActionTwo', 'postExecuteAction']),
    saveInsumo () {
      this.modelSend.empleado = this.user.empleado_id
      this.modelSend.departamento = this.user.departamento_id
      this.modelSend.tipo_actividad = 2
      this.modelSend.action = 'saveInsumo'
      if (this.get_dialogMain.type !== 'create') {
        this.modelSend.id = this.model.id
      }
      this.modelSend.insumos = this.table.body.data
      const router = this.get_urls['insumos.extras']
      this.postExecuteAction({ url: router, data: this.modelSend })
    },
    saveInsumoReturned () {
      this.modelSend.empleado = this.user.empleado_id
      this.modelSend.departamento = this.user.departamento_id
      this.modelSend.tipo_actividad = 2
      this.modelSend.action = 'saveReturnedInsumo'
      if (this.get_dialogMain.type !== 'create') {
        this.modelSend.id = this.model.id
      }
      this.insumos.push(...this.insumosReturned)
      this.modelSend.insumos = this.insumos
      const router = this.get_urls['insumos.extras']
      this.postExecuteAction({ url: router, data: this.modelSend })
    },
    addInsumo (model) {
      console.log(model)
      const descripcion = JSON.parse(model.insumo.descripcion)
      model.nombre = descripcion.nombre
      model.nuevo = true
      this.table.body.data.push(model)
      this.insumo = {}
    },
    up (obj) {
      const returned = (obj.returned) ? parseInt(obj.returned) : 0
      obj.message = (returned > obj.cantidad)
    },
    upAdd (obj) {
      const added = (obj.added) ? parseInt(obj.added) : 0
      obj.messageAdd = (added < 0)
    },
    ...mapMutations(['HIDDE_DIALOG_MAIN', 'SET_DATA_OBJECT_UPDATE', 'CLEAR_OBJECTS_MODEL']),
    closeDialog () {
      this.table.body.data = []
      this.model.last_movement.detalle.descripcion.insumos.map(item => {
        item.added = ''
        item.returned = ''
        item.message = false
        item.messageAdd = false
      })
      this.HIDDE_DIALOG_MAIN()
    }
  },
  computed: {
    ...mapGetters(['get_urls', 'get_dialogMain', 'get_model', 'get_objectFind'])
  },
  watch: {
    get_model (val) {
      if (val.message) {
        this.$swal({
          type: 'error',
          icon: 'error',
          title: 'Error !',
          text: val.message
        })
        return
      }
      this.$swal({
        type: 'succes',
        icon: 'success',
        title: 'Exitoso!',
        text: 'Registro agregado correctamente !!'
      })
      this.SET_DATA_OBJECT_UPDATE(val)
      this.CLEAR_OBJECTS_MODEL()
      this.closeDialog()
    }

  }
}
</script>
<style>

</style>
